module.exports = __webpack_public_path__ + "img/selected1-min.99653d5e.png";